<button class="btn">
  <div class="v-box align-center">
    <ng-template [ngIf]="iconName">
      <ion-icon [name]="iconName" class="icon"></ion-icon>
    </ng-template>
    <div class="label">
      <ng-content></ng-content>
    </div>
  </div>
  <ion-badge *ngIf="new" translate class="badge">BADGE.NEW</ion-badge>
</button>

<!-- Preload images to prevent flashing background with no image, images not visible -->
<img class="preload-img" src="assets/img/btn-leada/btn-leada-normal.png">
<img class="preload-img" src="assets/img/btn-leada/btn-leada-active.png">
